/**
 * +tutorial: the "Tutorial" practice card on Dungeons › Mythic+ (next to the dungeon cards).
 * Opens the hero pick, then the guided run. Uses the dungeon card styling (dungeons.css).
 */
import type { MetaScreenContext } from '../meta/context';
import { el } from '../meta/ui/dom';
import { primaryButton } from '../meta/kmmo';
import { tutorialPrefs } from './prefs';
import './tutorial.css';

export function tutorialCard(ctx: MetaScreenContext, parent: HTMLElement): HTMLElement | null {
  if (!ctx.openTutorial) return null;
  const card = el('article', 'kdg-card km-ornate practice tut-dg', parent);
  const base = (import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL ?? '/';
  el('div', 'kdg-art', card).style.setProperty('--art', `url("${base}assets/ui/dungeons/training_grounds.jpg")`);
  el('h3', 'kdg-name', card, 'Tutorial');
  const meta = el('div', 'kdg-meta', card);
  el('div', 'kdg-best', meta, 'Practice · guided · no rewards');
  el('div', 'kdg-meta-r', meta, 'About 5 min');
  const p = tutorialPrefs().get();
  const body = el('div', 'tut-dg-text', card);
  el('p', '', body, 'Move, target, then learn every one of your skills on a dummy, dodge orange, kick a caster and graduate on a real pull with a rotation score.');
  if (p.status === 'done') el('p', 'tut-dg-done', body, 'Completed. Replay it with any hero.');
  const foot = el('div', 'kdg-foot', card);
  primaryButton(p.status === 'done' ? 'Replay' : 'Start', { onClick: () => ctx.openTutorial?.() }, foot);
  return card;
}
